// Les Gardiens des Souvenirs et des Forces Intérieures — identité visuelle Passerelle
// Portraits découpés de l'affiche originale de la collection (fournie par la fondatrice).

export const GARDIENS = [
  // ---- Les Gardiens des Souvenirs ----
  {
    id: "eloise", collection: "souvenirs",
    name: "Éloïse", title: "La Gardienne des Souvenirs", value: "Mémoire",
    quote: "Aucun souvenir ne disparaît vraiment tant qu'il est aimé.",
    story: "Éloïse a passé sa vie à relire les lettres de sa famille à la lueur de la cuisine. Elle sait qu'un souvenir partagé ne s'use jamais, et elle aide chacun à retrouver les siens, une photo à la fois.",
    pathologie: "Alzheimer",
    therapie: "Stimulation de la mémoire",
    pathoRef: 1,
    familiar: { name: "Célestin", title: "le Rouge-Gorge des Souvenirs", image: "/gardiens/familier-eloise.jpg?v=4", story: "Célestin chantait chaque matin sur le rebord de la fenêtre d'Éloïse. On dit que sa mélodie aide les souvenirs à retrouver leur chemin jusqu'au cœur." },
    image: "/gardiens/eloise.jpg?v=4", category: "Mémoire", color: "#C46A85",
    activities: [
      "Créer ensemble une boîte à souvenirs avec des objets, photos et parfums d'antan",
      "Feuilleter l'album photo en laissant chaque image raconter son histoire",
      "Retrouver une odeur d'autrefois — un plat, une fleur, un savon",
    ],
  },
  {
    id: "leontine", collection: "souvenirs",
    name: "Léontine", title: "La Semeuse de Sourires", value: "Optimisme",
    quote: "Les sourires d'aujourd'hui sont les souvenirs de demain.",
    story: "Léontine semait des graines de tournesol dans son jardin, et des sourires partout ailleurs. Elle murmure que la joie d'aujourd'hui deviendra le doux souvenir de demain.",
    pathologie: "Burn-out et épuisement",
    therapie: "Thérapie positive",
    pathoRef: 3,
    familiar: { name: "Mimo", title: "l'Écureuil des Sourires", image: "/gardiens/familier-leontine.jpg?v=4", story: "Mimo cachait des noisettes dans les poches de Léontine, et des sourires un peu partout. Il paraît qu'il en garde toujours une pour les jours de pluie." },
    image: "/gardiens/leontine.jpg?v=4", category: "Apaisement", color: "#D9A125",
    activities: [
      "Le bocal à bonheurs : glisser chaque jour une note joyeuse",
      "Partager chaque soir trois belles choses de la journée",
      "Une séance photo « sourires » à afficher près du lit",
    ],
  },
  {
    id: "arsene", collection: "souvenirs",
    name: "Arsène", title: "Le Conteur des Histoires", value: "Transmission",
    quote: "Une histoire racontée est un trésor partagé.",
    story: "Arsène a lu mille histoires à voix haute, sa chouette apprivoisée sur l'épaule. Il sait qu'une histoire racontée devient un trésor que rien ne peut voler.",
    pathologie: "Perte des repères",
    therapie: "Thérapie narrative",
    pathoRef: 1,
    familiar: { name: "Oscar", title: "la Chouette des Histoires", image: "/gardiens/familier-arsene.jpg?v=4", story: "Oscar a écouté mille histoires du haut de la bibliothèque d'Arsène. Il n'oublie jamais une fin heureuse et veille sur chaque récit comme sur un trésor." },
    image: "/gardiens/arsene.jpg?v=4", category: "Mémoire", color: "#8A6B4F",
    activities: [
      "Enregistrer sa voix en train de raconter un souvenir marquant",
      "Écrire ensemble « l'histoire de sa vie » chapitre par chapitre",
      "Dessiner l'arbre généalogique en racontant chaque prénom",
    ],
  },
  {
    id: "madeleine", collection: "souvenirs",
    name: "Madeleine", title: "La Jardinière du Temps", value: "Patience",
    quote: "Les plus belles choses poussent lentement.",
    story: "Madeleine a appris du jardin que rien ne pousse plus vite que la patience. Elle prend le temps, toujours, et montre que les plus belles choses mûrissent lentement.",
    pathologie: "Dépression",
    therapie: "Thérapie par la patience et le temps",
    pathoRef: 3,
    familiar: { name: "Capucine", title: "la Tortue du Temps", image: "/gardiens/familier-madeleine.jpg?v=4", story: "Capucine avance lentement, très lentement, et c'est sa plus grande leçon. Auprès de Madeleine, elle rappelle que le temps bien employé guérit presque tout." },
    image: "/gardiens/madeleine.jpg?v=4", category: "Stimulation", color: "#7D9B6A",
    activities: [
      "Jardinage sensoriel : toucher la terre, sentir les herbes, arroser ensemble",
      "Puzzles et tri de graines ou de boutons, sans chrono ni pression",
      "Semer des graines et observer leur pousse jour après jour",
    ],
  },
  {
    id: "lucien", collection: "souvenirs",
    name: "Lucien", title: "Le Messager des Cœurs", value: "Liens Précieux",
    quote: "L'amitié est un jardin que l'on cultive ensemble.",
    story: "Lucien fut facteur pendant quarante ans : il connaissait chaque prénom, chaque portail, chaque attente. Pour lui, l'amitié est un jardin qui ne demande qu'à être arrosé.",
    pathologie: "Isolement social",
    therapie: "Thérapie du lien",
    pathoRef: 3,
    familiar: { name: "Azur", title: "le Renard des Amitiés", image: "/gardiens/familier-lucien.jpg?v=4", story: "Azur connaissait tous les chemins du village et tous ceux qui les empruntaient. Compagnon de Lucien, il n'a jamais laissé personne se sentir seul sur la route." },
    image: "/gardiens/lucien.jpg?v=4", category: "Repères", color: "#5B8DB8",
    activities: [
      "Écrire ou dicter une carte à un vieil ami",
      "Programmer un appel vidéo mensuel avec un proche éloigné",
      "Créer un album des amis avec photos et petits mots",
    ],
  },
  {
    id: "rose-auguste", collection: "souvenirs",
    name: "Rose & Auguste", title: "Les Gardiens de l'Amour", value: "Amour",
    quote: "Les années passent, l'amour demeure.",
    story: "Rose et Auguste se sont aimés soixante ans, main dans la main, à travers toutes les saisons. Ils rappellent que les années passent, mais que l'amour, lui, demeure.",
    pathologie: "Deuil",
    therapie: "Thérapie de l'amour durable",
    pathoRef: 3,
    familiar: { name: "Perle", title: "le Cygne du Grand Amour", image: "/gardiens/familier-rose-auguste.jpg?v=4", story: "Perle glisse sur l'étang où Rose et Auguste se sont promis leur amour. Fidèle entre toutes, elle n'a jamais quitté le rivage de leur histoire." },
    image: "/gardiens/rose-auguste.jpg?v=4", category: "Mémoire", color: "#C47A6E",
    activities: [
      "Réécouter « leur » chanson en se tenant la main",
      "Recréer ensemble le menu d'un repas d'amoureux d'autrefois",
      "Assembler un album du couple : fiançailles, mariage, grandes dates",
    ],
  },
  {
    id: "celestine", collection: "souvenirs",
    name: "Célestine", title: "La Gardienne des Rêves", value: "Imagination",
    quote: "Il n'y a pas d'âge pour rêver.",
    story: "Célestine regarde la lune avec sa lanterne et collectionne les rêves comme des étoiles. Elle souffle qu'il n'y a pas d'âge pour rêver — jamais.",
    pathologie: "Troubles du sommeil",
    therapie: "Thérapie par l'imagination",
    pathoRef: 3,
    familiar: { name: "Stella", title: "l'Étoile des Rêves", image: "/gardiens/familier-celestine.jpg?v=4", story: "Stella est la première étoile que Célestine salue chaque soir. Elle scintille un peu plus fort quand quelqu'un fait un beau rêve." },
    image: "/gardiens/celestine.jpg?v=4", category: "Stimulation", color: "#6B7BB8",
    activities: [
      "Inventer une histoire à partir d'une belle image ou d'un nuage",
      "Peindre ou dessiner librement, sans modèle ni jugement",
      "Observer les étoiles ou les lucioles et rêver à voix haute",
    ],
  },
  {
    id: "gaston", collection: "souvenirs",
    name: "Gaston", title: "Le Musicien des Émotions", value: "Joie",
    quote: "Une mélodie retrouve toujours le chemin du cœur.",
    story: "Gaston et son violon ont fait danser trois générations. Il sait qu'une mélodie retrouve toujours le chemin du cœur, même quand les mots se perdent.",
    pathologie: "Anxiété",
    therapie: "Musicothérapie",
    pathoRef: 3,
    familiar: { name: "Allegro", title: "le Grillon Musicien", image: "/gardiens/familier-gaston.jpg?v=4", story: "Allegro chantait sous le violon de Gaston, en parfait rythme. Son petit concert du soir apaise les cœurs agités mieux que n'importe quel remède." },
    image: "/gardiens/gaston.jpg?v=4", category: "Stimulation", color: "#B8722E",
    activities: [
      "Créer la playlist des chansons de sa jeunesse et l'écouter ensemble",
      "Chanter à tue-tête ou à voix douce, comme il ou elle préfère",
      "Petit orchestre de cuisine : cuillères, casseroles et fous rires",
    ],
  },
  {
    id: "josephine", collection: "souvenirs",
    name: "Joséphine", title: "La Gardienne de la Sérénité", value: "Sérénité",
    quote: "Le calme est une lumière intérieure.",
    story: "Joséphine allumait une lanterne chaque soir pour apaiser toute la maison. Elle enseigne que le calme est une lumière intérieure qui ne demande qu'à être regardée.",
    pathologie: "Stress",
    therapie: "Thérapie de la sérénité",
    pathoRef: 3,
    familiar: { name: "Colombe", title: "la Biche de la Sérénité", image: "/gardiens/familier-josephine.jpg?v=4", story: "Colombe traversait la forêt sans faire de bruit, et Joséphine l'admirait pour cela. Sa simple présence suffit à ralentir le souffle et à calmer la maison." },
    image: "/gardiens/josephine.jpg?v=4", category: "Apaisement", color: "#4A8B6F",
    activities: [
      "Un moment de respiration guidée, main sur le cœur",
      "Plaid lesté, tisane tiède et lumière tamisée en fin de journée",
      "Écouter le bruit de la pluie ou d'une fontaine, les yeux fermés",
    ],
  },
  // ---- Les Gardiens des Forces Intérieures ----
  {
    id: "theodore", collection: "forces",
    name: "Théodore", title: "Le Gardien de la Constance", value: "Stabilité - Sécurité",
    quote: "Les racines profondes permettent aux branches de s'élever.",
    story: "Théodore répare les jouets et les meubles dans son atelier, son chien fidèle à ses pieds. Il sait que les racines profondes permettent aux branches de s'élever.",
    pathologie: "Autisme",
    therapie: "Thérapie par la routine",
    pathoRef: 2,
    familiar: { name: "Pacha", title: "le Chien de la Constance", image: "/gardiens/familier-theodore.jpg?v=4", story: "Pacha attend chaque matin au même endroit de l'atelier, à la même heure. Sa routine tranquille est le premier repère de la journée de Théodore." },
    image: "/gardiens/theodore.jpg?v=5", category: "Repères", color: "#8A6B4F",
    activities: [
      "Instaurer un rituel du matin toujours identique, rassurant comme un refrain",
      "La même tasse, le même thé, à la même heure — les petites ancres du jour",
      "Un emploi du temps en images affiché près du lit",
    ],
  },
  {
    id: "silas", collection: "forces",
    name: "Silas", title: "Le Gardien de l'Expression", value: "Communication - Créativité",
    quote: "Lorsque les mots se cachent, le cœur trouve un autre chemin.",
    story: "Silas peint ce que les mots ne disent plus. Il montre que lorsque les mots se cachent, le cœur trouve toujours un autre chemin pour se faire entendre.",
    pathologie: "Aphasie",
    therapie: "Orthophonie",
    pathoRef: 1,
    familiar: { name: "Pastel", title: "le Pinceau de l'Expression", image: "/gardiens/familier-silas.jpg?v=4", story: "Pastel a peint des soleils quand les mots manquaient à Silas. Un peu de couleur sur le papier, et les émotions retrouvent leur voix." },
    image: "/gardiens/silas.jpg?v=5", category: "Stimulation", color: "#7D6B8A",
    activities: [
      "Chanter ensemble quand les mots ne viennent plus",
      "Communiquer par images et pictogrammes, sans jamais forcer",
      "Écrire à sa place les mots qu'il ou elle n'arrive plus à dire",
    ],
  },
  {
    id: "aurelien", collection: "forces",
    name: "Aurélien", title: "Le Gardien de l'Éveil", value: "Sensations - Émerveillement",
    quote: "Le monde est rempli de merveilles qui attendent d'être ressenties.",
    story: "Aurélien marche dans les champs les bras ouverts, émerveillé par chaque papillon. Il invite à redécouvrir la beauté du monde avec tous ses sens.",
    pathologie: "Troubles sensoriels",
    therapie: "Thérapie sensorielle",
    pathoRef: 2,
    familiar: { name: "Lumen", title: "le Papillon de l'Émerveillement", image: "/gardiens/familier-aurelien.jpg?v=4", story: "Lumen ne se pose jamais deux fois au même endroit. Elle a appris à Aurélien que le monde se découvre en le regardant bouger." },
    image: "/gardiens/aurelien.jpg?v=5", category: "Stimulation", color: "#D9A125",
    activities: [
      "La boîte sensorielle : textures, odeurs et sons à découvrir à son rythme",
      "Observer longuement une plume, une pierre polie, un bocal de lavande",
      "Marcher lentement en nommant chaque merveille croisée",
    ],
  },
  {
    id: "adele", collection: "forces",
    name: "Adèle", title: "La Gardienne des Repères", value: "Organisation - Confiance",
    quote: "Un repère bienveillant éclaire toujours le chemin.",
    story: "Adèle range les journées comme on range une bibliothèque : chaque chose à sa place, chaque repère à portée de main. Sa douce organisation rend le monde lisible et rassurant.",
    pathologie: "Troubles cognitifs",
    therapie: "Structuration cognitive",
    pathoRef: 1,
    familiar: { name: "Cap", title: "la Boussole des Repères", image: "/gardiens/familier-adele.jpg?v=4", story: "Cap fut offerte à Adèle par son grand-père, et n'a jamais perdu le nord. Posée au bon endroit, elle rappelle que chaque chose a sa place." },
    image: "/gardiens/adele.jpg?v=5", category: "Repères", color: "#5B8DB8",
    activities: [
      "Préparer la journée ensemble avec des cartes visuelles",
      "Chaque objet a sa place, marquée d'une étiquette-image",
      "La routine du soir racontée en cinq images apaisantes",
    ],
  },
  {
    id: "marianne", collection: "forces",
    name: "Marianne", title: "La Gardienne du Réconfort", value: "Apaisement - Soutien",
    quote: "Les petits gestes doux changent les grands jours.",
    story: "Marianne tricote des écharpes qui réchauffent bien plus que les épaules. Elle sait que les petits gestes doux changent les grands jours.",
    pathologie: "Troubles anxieux",
    therapie: "Thérapie de l'apaisement",
    pathoRef: 2,
    familiar: { name: "Câline", title: "la Chatte du Réconfort", image: "/gardiens/familier-marianne.jpg?v=4", story: "Câline ronronne sur les genoux de Marianne dès que les aiguilles s'affairent. Son ronron est une berceuse que rien ne remplace." },
    image: "/gardiens/marianne.jpg?v=5", category: "Apaisement", color: "#4A8B6F",
    activities: [
      "Le plaid lesté et une main posée doucement sur l'épaule",
      "La boîte à réconfort : doudou, photo aimée, mouchoir parfumé",
      "Vingt secondes de tendresse, sans rien demander en retour",
    ],
  },
  {
    id: "emile", collection: "forces",
    name: "Émile", title: "Le Gardien de l'Adaptation", value: "Résilience - Évolution",
    quote: "Même les rivières trouvent un nouveau chemin.",
    story: "Émile a traversé bien des rivières et rebâti bien des cabanes. Il raconte que même les rivières trouvent un nouveau chemin — et que nous le pouvons aussi.",
    pathologie: "Handicap moteur",
    therapie: "Thérapie de la résilience",
    pathoRef: 3,
    familiar: { name: "Ondine", title: "la Loutre de la Résilience", image: "/gardiens/familier-emile.jpg?v=4", story: "Ondine glisse dans la rivière en jouant, même contre le courant. Elle a montré à Émile qu'on avance aussi en s'adaptant à l'eau." },
    image: "/gardiens/emile.jpg?v=5", category: "Apaisement", color: "#8A7B9B",
    activities: [
      "Célébrer chaque petit « j'ai réussi » du jour, même minuscule",
      "Changer une habitude en douceur, un tout petit pas à la fois",
      "Raconter comment la rivière contourne les pierres, sans jamais s'arrêter",
    ],
  },
  {
    id: "agathe", collection: "forces",
    name: "Agathe", title: "La Gardienne de la Curiosité", value: "Découverte - Apprentissage",
    quote: "Chaque question ouvre une nouvelle porte.",
    story: "Agathe plante des questions comme d'autres plantent des fleurs, sa loupe toujours à la main. Chaque question, dit-elle, ouvre une nouvelle porte.",
    pathologie: "Troubles de l'attention",
    therapie: "Thérapie par la curiosité",
    pathoRef: 3,
    familiar: { name: "Loupiote", title: "la Loupe de la Curiosité", image: "/gardiens/familier-agathe.jpg?v=4", story: "Loupiote a révélé à Agathe des mondes entiers cachés dans une goutte de rosée. Regarder de près, c'est déjà voyager." },
    image: "/gardiens/agathe.jpg?v=5", category: "Stimulation", color: "#C46A85",
    activities: [
      "La boîte à questions : tirer une question rigolote ou tendre par jour",
      "Devinettes et petits jeux de détective à deux",
      "Observer une photo ancienne et imaginer ensemble son histoire",
    ],
  },
  {
    id: "victor", collection: "forces",
    name: "Victor", title: "Le Gardien de l'Attention", value: "Concentration - Présence",
    quote: "Écouter une chose à la fois révèle sa beauté.",
    story: "Victor sait écouter le silence et regarder une seule chose à la fois. Il révèle que l'attention posée sur un instant suffit à en dévoiler la beauté.",
    pathologie: "TDA/H",
    therapie: "Thérapie de la concentration",
    pathoRef: 3,
    familiar: { name: "Mélodie", title: "le Rossignol de l'Écoute", image: "/gardiens/familier-victor.jpg?v=4", story: "Mélodie chante si juste que Victor s'arrête toujours pour l'écouter. Un seul chant, écouté vraiment, suffit à remplir l'instant." },
    image: "/gardiens/victor.jpg?v=5", category: "Stimulation", color: "#6B7BB8",
    activities: [
      "Un seul jeu à la fois, posé sur une table dégagée",
      "Cherche-et-trouve dans une grande image détaillée",
      "Cinq minutes de dominos ou de tri de cartes, en silence partagé",
    ],
  },
];

export const COLLECTIONS = [
  { id: "souvenirs", label: "Les Gardiens des Souvenirs", intro: "Ils veillent sur les émotions précieuses : la mémoire, la transmission, l'amitié, l'amour, la joie, les rêves, la sérénité, l'optimisme et la patience." },
  { id: "forces", label: "Les Gardiens des Forces Intérieures", intro: "Ils révèlent les trésors que chaque personne porte en elle : constance, expression, éveil, repères, réconfort, adaptation, curiosité et attention." },
];

export const gardienById = (id) => GARDIENS.find((g) => g.id === id);

// Association des univers de l'application Passerelle à leurs Gardiens
export const APP_UNIVERS = [
  { label: "Jeux Alzheimer", gardienIds: ["eloise"] },
  { label: "Contes & Poésie", gardienIds: ["arsene"] },
  { label: "Jeux de Routine", gardienIds: ["madeleine", "theodore"] },
  { label: "Jeux Autisme", gardienIds: ["celestine", "marianne"] },
  { label: "Blind Test Musical", gardienIds: ["gaston"] },
  { label: "Apaisement", gardienIds: ["josephine"] },
  { label: "Jeux Aphasie", gardienIds: ["silas"] },
  { label: "Jeux Sensoriels", gardienIds: ["aurelien"] },
  { label: "Parcours Thérapeutique", gardienIds: ["emile"] },
  { label: "Exercices de Concentration", gardienIds: ["victor"] },
];

// Association des sections du site à leur Gardien
export const SECTION_GARDIENS = {
  accueil: "leontine",
  forum: "rose-auguste",
  quiz: "agathe",
  "espace-familles": "lucien",
  admin: "adele",
  pathologies: "emile",
};

// Gardien fétiche de chaque produit de la boutique (clé = slug produit)
export const PRODUCT_GARDIENS = {
  "boite-souvenirs": "eloise",
  "plaid-lesté": "marianne",
  "coussin-tactile": "aurelien",
  "set-bois": "victor",
  "horloge-jour-nuit": "adele",
  "album-grande-police": "lucien",
  "bougie-parfum-souvenir": "josephine",
  "coeur-resine-souvenir": "rose-auguste",
};
